import { Link } from "gatsby";
import React from "react";
import {
  blogContainer,
  fontContainer,
  imageContainer,
  linkContainer,
  mainContainerHeader,
  blogContainerHeader,
  mainContainer,
} from "./styles";
import {
  getDateString,
  slugify,
  useFindCategories,
  useFindImages,
  useGetImage,
} from "@provider";
import { BlogElementProps } from "./types";
import settings from "@settings";
import { Label } from "../Label";
import { FlexBox } from "../FlexBox";
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image";

const BlogElement: React.FC<BlogElementProps> = ({
  type = "tile",
  title,
  categories,
  image,
  date,
  flex,
}) => {
  const { findCategories } = useFindCategories();
  const { findImage } = useFindImages();

  if (type === "tile") {
    return (
      <div css={blogContainer(flex)}>
        <Link to={`/aktuelles/${slugify(title)}`} css={linkContainer}>
          {title}
        </Link>
        <div css={imageContainer}>
          <GatsbyImage
            alt={title || "TV Freiburg St. Georgen"}
            imgStyle={{ width: "100%", height: "240px" }}
            image={findImage(image)}
          />
        </div>
        <div>
          <FlexBox
            direction="row"
            align="center"
            justify="flex-start"
            gap={settings.sizes.small}
          >
            {categories && categories.length > 0
              ? findCategories(categories).map((category, index) => {
                  return <Label text={category?.title || ""} key={index} />;
                })
              : null}
          </FlexBox>
          <div css={fontContainer}>
            <h3>{title}</h3>
          </div>
          <div>
            <h4
              css={{
                marginBottom: 0,
                color: `${settings.colors.grey} !important`,
              }}
            >
              {getDateString(date).date}
            </h4>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div css={blogContainerHeader}>
      <Link to={`/aktuelles/${slugify(title)}`} css={linkContainer}>
        {title}
      </Link>
      <div
        css={settings.mq({
          width: "100%",
          maxWidth: "800px",
          overflow: "hidden",
          display: "inline-block",
        })}
      >
        <GatsbyImage
          alt={title}
          css={[imageContainer, { height: "auto !important" }]}
          image={findImage(image)}
        />
      </div>
      <div css={mainContainerHeader}>
        <FlexBox
          direction="row"
          align="center"
          justify="flex-start"
          gap={settings.sizes.small}
        >
          {categories && categories.length > 0
            ? findCategories(categories).map((category, index) => {
                return <Label text={category?.title || ""} key={index} />;
              })
            : null}
        </FlexBox>
        <h2>{title}</h2>
        <h3>{getDateString(date).date}</h3>
      </div>
    </div>
  );
};

export default BlogElement;
